<template>
  <div id="filters">
    <div class="search col-lg-12 col-md-12">
      <div class="col-lg-3 col-md-3 m-t-sm">
        <v-select
          placeholder="Clients"
          :options="f.clients"
          label="name"
          multiple
          v-model="multiFilters['clients']"
        ></v-select>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div class="display-flex">
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input side-input-text">Period</div>
          <input type="date" v-model="filters['dateFrom']" min="0" name="" placeholder="from" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" @keydown.enter="search">
          <input type="date" v-model="filters['dateTo']" min="0" name="" placeholder="to" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" @keydown.enter="search">
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <v-select placeholder="Group by" :options="groupBy" v-model="filters['groupBy']" index="id"></v-select>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 m-t-sm">
      <div class="col-lg-3">
        <button class="btn btn-primary btn-xs" @click="search">Generate</button>
        <button class="btn btn-success btn-xs" @click="search(true)"><i class="fa fa-download"></i> Download</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { Browser, Query } from '../../../../../mixins/helperMixin'
import { mapGetters } from 'vuex'
import { BUILD_REPORT_SET } from '../../../../../store/mutation-types'

export default {
  data () {
    return {
      filters: {},
      multiFilters: [],
      groupBy: [
        {label: 'Client', id: 'client'},
        {label: 'Group', id: 'group'}
      ]
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  mixins: [Query],
  methods: {
    search (csv = false) {
      let query = this.buildQuery(this.filters, this.multiFilters)
      axios.get('/pbn/build/report?' + query, {
        headers: {
          'Accept': csv === true ? 'text/csv' : 'application/json'
        }
      })
        .then(r => {
          if (csv === true) {
            Browser.methods.downloadFile('pbn-build-report.csv', r.data.data)
          } else {
            this.$store.commit(BUILD_REPORT_SET, r.data.data)
          }
        })
        .catch(e => {
          this.$toastr.error(e, 'Sorry')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Overview/Report/Filters.vue